<template>
  <div class="graphic-typographic-content" id="identidade-visual-grafismos-tipografico" data-search-anchor>
    <div class="graphic-typographic-title-wrapper">
      <h1 class="graphic-typographic-title-span">{{ graphicTypographicTitleSpan }}</h1>
      <h1 class="graphic-typographic-title">{{ graphicTypographicTitle }}</h1>
    </div>
    <div class="description-graphic-typographic-title-icons-wrapper">
      <div class="graphic-typographic-icon-wrapper-first">
        <p class="graphic-typographic-description">{{ graphicTypographicDescription1 }}</p>
      </div>

      <div>
        <p class="graphic-typographic-description">{{ graphicTypographicDescription2 }}</p>
      </div>

      <div class="graphic-typographic-icon-wrapper">
        <p class="fica-a-dica" style="margin: 0;">{{ graphicTypographicDescription3 }}</p>
        <div class="graphic-typographic-dica-icon">
          <IconCheck />
          <div class="fica-a-dica">
            <p class="graphic-typographic-description-fica-a-dica4">{{ graphicTypographicDescription4 }}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="graphic-typographic-card-item" style="margin-bottom: 1rem;"
      :style="{ backgroundImage: `url(${ImageSrc})` }"
    ></div>

    <div
      class="graphic-typographic-card-item"
      :style="{ backgroundImage: `url(${ImageSrc2})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import GraphicPageMixin from '@/mixins/graphic-page-mixin'
import { GraphicPageStore } from '@/store/visual-identity-page/graphic-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class GraphicsTypographicSection extends Mixins(GraphicPageMixin) {
  graphicPageStore: PageStoreContract = getModule(GraphicPageStore, this.$store)

  get graphicTypographicTitleSpan(): string {
    return this.getElementTitle(6, 0)
  }

  get graphicTypographicTitle(): string {
    return this.getElementText(6, 0)
  }

  get graphicTypographicDescription1(): string {
    return this.getElementText(6, 1)
  }

  get graphicTypographicDescription2(): string {
    return this.getElementText(6, 2)
  }

  get graphicTypographicDescription3(): string {
    return this.getElementText(6, 3)
  }

  get graphicTypographicDescription4(): string {
    return this.getElementText(6, 4)
  }

  get ImageSrc(): string {
    return this.getElementMedia(6, 5)
  }

  get ImageSrc2(): string {
    return this.getElementMedia(6, 6)
  }

  async getGraphicPage(): Promise<void> {
    await this.graphicPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.graphicPageStore.isLoading) {
      await this.getGraphicPage()
    }
  }
}
</script>

<style lang="scss">
.graphic-typographic-content {
  display: grid;
  max-width: 1032px;
}

.graphic-typographic-title-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.graphic-typographic-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-right: 5px;
  color: #b3b3b3;
}

.graphic-typographic-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #000000;
}

.description-graphic-typographic-title-icons-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: 51.2% 48.8%;  
}

.graphic-typographic-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  margin-top: 0;

  width: 430px;
}

.graphic-typographic-icon-wrapper-first {
  display: flex;
  white-space: pre-line;
}

.graphic-typographic-icon-wrapper {
  display: flex;
  flex-direction: column;
}

.graphic-typographic-card-item {
  position: relative;
  width: 1032px;
  height: 705px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.fica-a-dica,
.graphic-typographic-description-fica-a-dica4 {
  font-size: 16px;  
  line-height: 20px;
  text-align: left;
  
  padding-left: 7px;
  width: 378px;
  white-space: pre-line;
}

.graphic-typographic-dica-icon{
  display: flex;
  align-items: center;
}

.graphic-typographic-description-fica-a-dica4{
  font-weight: 600;
}
</style>
